import { Component, Input, OnInit } from '@angular/core';
import { DisclosureVariants, GatekeeperService } from '@vanguard/secure-site-components-lib';

@Component({
  selector: 'app-disclaimers',
  templateUrl: './disclaimers.component.html',
  styleUrls: ['./disclaimers.component.scss'],
})
export class DisclaimersComponent implements OnInit {
  @Input() hasCashManagementAccount: boolean;
  @Input() hasPrivateEquityAccount: boolean;
  @Input() hasPersonalTrustAccount: boolean;

  DisclosureVariants: typeof DisclosureVariants = DisclosureVariants;
  cashPlusDisclosureVariant: typeof DisclosureVariants[keyof typeof DisclosureVariants];

  constructor(private gateKeeperService: GatekeeperService) {}

  ngOnInit(): void {
    this.gateKeeperService.getStatus('showCashPlusMMFTrade').then((result) => {
      this.cashPlusDisclosureVariant = !!result
        ? DisclosureVariants.CASH_PLUS_DISCLOSURE_V2
        : DisclosureVariants.CASH_PLUS_DISCLOSURE;
    });
  }
}
